import React, { useMemo } from 'react';
import pickBy from 'lodash/pickBy';
import { Chip } from '@vectord/components';
import { useSelector } from 'react-redux';
import { DateUtils, TypeUtils } from '@vectord/utils';
import classNames from 'classnames';

import {
  isValidSbatGroupFilter,
  rescheduleClassesAppliedFiltersSelector,
  RESCHEDULE_CLASSES_FILTERS,
  RESCHEDULE_CLASSES_FILTER_LABELS,
} from 'features/classCreation';
import styles from './RescheduleClassesTypeChip.module.scss';

function RescheduleClassesTypeChip() {
  const appliedFilters = useSelector(rescheduleClassesAppliedFiltersSelector);

  const filters = useMemo(() => {
    return pickBy(appliedFilters, isValidSbatGroupFilter);
  }, [appliedFilters]);

  return Object.keys(filters).map((filterKey) => {
    let label = `${RESCHEDULE_CLASSES_FILTER_LABELS[filterKey]}: `;

    if (
      filterKey === RESCHEDULE_CLASSES_FILTERS.fromDate ||
      filterKey === RESCHEDULE_CLASSES_FILTERS.toDate
    ) {
      label = label + DateUtils.toDDMMMYYYY(filters[filterKey]);
    } else if (TypeUtils.isArray(filters[filterKey])) {
      const filterList = filters[filterKey]
        .map((filter) => filter.label)
        .join(', ');
      label = label + filterList;
    } else {
      label = label + filters[filterKey].label;
    }

    return (
      <Chip
        className={classNames(styles.root, 'h5 m-r-xxs')}
        key={filterKey}
      >
        {label}
      </Chip>
    );
  });
}

export default RescheduleClassesTypeChip;
